import { render, staticRenderFns } from "./YJTD.vue?vue&type=template&id=0f9948e8&"
import script from "./YJTD.vue?vue&type=script&lang=js&"
export * from "./YJTD.vue?vue&type=script&lang=js&"
import style0 from "./YJTD.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports